import Vue from 'vue'

const queryChangeParamsCSS = Vue.observable([])

export default {
    mounted(){
        Vue.set(this, 'queryChangeParamsCSS', queryChangeParamsCSS)
    }
}